import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import {NavigationExtras, Router} from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private toastrService : ToastrService, private router: Router) {}

    intercept(req: HttpRequest<any>, next : HttpHandler) {
        return next.handle(req).pipe(
            catchError((err:any, caught : Observable<any>)=>{
                if(err instanceof HttpErrorResponse){
                	if(err.error.esito != 0){
                		this.router.navigateByUrl("error/"+err.error.esito);
						return throwError(err);
					}
                    this.toastrService.error(null, "An error occurred", {
                        disableTimeOut : true
                    });
                    return throwError(err);
                }
            })
        );
    }

}